import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant pour afficher un nœud Prompt
 */
const PromptNodeLabel = ({ routingKey, routing, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  const routingId = routingKey === '0' ? 'routing-0' : `routing-${routingKey}`;
  const displayName = routingKey === '0' ? t('START') : (routing.displayName || routing.routingName || routingKey);
  const promptName = routing.promptName || t('PROMPT');
  const isDefaultRouting = routingKey === '0';

  return (
    <div 
      className="node-prompt"
      onClick={() => handleEditNode(routingId)}
      style={{ cursor: 'pointer' }}
    >
      {/* Menu d'actions */}
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              icon={<Edit20Regular />}
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode(routingId);
              }}
            >
              Éditer
            </MenuItem>
            {!isDefaultRouting && (
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(routingId);
                }}
              >
                Supprimer
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>

      {/* Titre */}
      <div className="node-title">{displayName}</div>
      <div className="node-separator"></div>

      {/* Informations */}
      <div className="node-info">
        <div className="node-info-item">{t('PROMPT')}</div>
        {promptName !== t('PROMPT') && (
          <div className="node-info-item" style={{ fontWeight: 600 }}>{promptName}</div>
        )}
      </div>
    </div>
  );
};

export default PromptNodeLabel;
